import React from 'react';
import { Link } from 'react-router-dom';
import SortableHeader from '../../components/SortableHeader';
import { Plus } from 'lucide-react';
import { fmtCurrency } from '../../utils/formatCurrency';

function getQuoteStatusColor(status) {
  switch (status) {
    case 'Draft': return 'gray';
    case 'Sent': return 'primary';
    case 'Accepted': return 'success';
    case 'Rejected': return 'danger';
    default: return 'gray';
  }
}

function AccountQuotesTab({
  accountId,
  sortedQuotes,
  quotesSort,
  handleQuotesSort,
  canDo,
  setShowQuoteModal,
}) {
  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Quotes</h3>
        {canDo('quotes', 'create') && (
          <button className="btn btn-primary btn-sm" onClick={() => setShowQuoteModal(true)}>
            <Plus size={16} />
            New Quote
          </button>
        )}
      </div>
      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <SortableHeader label="Quote #" field="quote_number" sortField={quotesSort.field} sortDirection={quotesSort.direction} onSort={handleQuotesSort} />
              <SortableHeader label="Contact" field="contact_name" sortField={quotesSort.field} sortDirection={quotesSort.direction} onSort={handleQuotesSort} />
              <SortableHeader label="Total" field="total" sortField={quotesSort.field} sortDirection={quotesSort.direction} onSort={handleQuotesSort} />
              <SortableHeader label="Status" field="status" sortField={quotesSort.field} sortDirection={quotesSort.direction} onSort={handleQuotesSort} />
              <SortableHeader label="Created" field="created_at" sortField={quotesSort.field} sortDirection={quotesSort.direction} onSort={handleQuotesSort} />
            </tr>
          </thead>
          <tbody>
            {sortedQuotes.length > 0 ? (
              sortedQuotes.map(quote => (
                <tr key={quote.id}>
                  <td>
                    <Link to={`/quotes/${quote.id}`} state={{ fromAccount: accountId }}>{quote.quote_number}</Link>
                  </td>
                  <td>{quote.contact_name || '-'}</td>
                  <td>${fmtCurrency(quote.total)}</td>
                  <td>
                    <span className={`badge badge-${getQuoteStatusColor(quote.status)}`}>
                      {quote.status}
                    </span>
                  </td>
                  <td>{new Date(quote.created_at).toLocaleDateString()}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center text-secondary">No quotes</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default AccountQuotesTab;
